var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "plan-task-crud" },
    [
      _vm.urlId || _vm.action
        ? [
            _vm.action === _vm.taskActions.add
              ? _c("PlanUrlAddTaskModal", {
                  attrs: {
                    "hide-header-btn": _vm.hideHeaderBtn,
                    "iframe-view": _vm.iframeView,
                  },
                  on: {
                    close: function ($event) {
                      _vm.$emit("close")
                      _vm.$plan.resetPlanCRUDState()
                      _vm.$plan.setPlanAction(null)
                    },
                    planTaskCreated: _vm.planTaskCreated,
                  },
                })
              : _vm.action === _vm.taskActions.create && _vm.urlId
              ? _c("PlanUrlNewTaskModal", {
                  attrs: {
                    urlId: _vm.urlId,
                    service: _vm.service,
                    "hide-header-btn": _vm.hideHeaderBtn,
                    "iframe-view": _vm.iframeView,
                  },
                  on: {
                    close: function ($event) {
                      _vm.$emit("close")
                      _vm.$plan.resetPlanCRUDState()
                      _vm.$plan.setPlanAction(null)
                    },
                    planTaskCreated: _vm.planTaskCreated,
                  },
                })
              : _vm.action === _vm.taskActions.view && _vm.taskId
              ? _c("PlanUrlTaskModal", {
                  attrs: {
                    urlTaskId: _vm.taskId,
                    service: _vm.service,
                    "hide-header-btn": _vm.hideHeaderBtn,
                    "iframe-view": _vm.iframeView,
                    runId: _vm.runId,
                    urlId: _vm.urlId,
                    "is-access-allow": _vm.isTaskAccess,
                  },
                  on: {
                    close: function ($event) {
                      _vm.$emit("close")
                      _vm.$plan.resetPlanCRUDState()
                      _vm.$plan.setPlanAction(null)
                    },
                    openTasks: function ($event) {
                      return _vm.listPlanTask()
                    },
                    requestError: (err) => (_vm.requestErrorMessage = err),
                  },
                })
              : _vm.action === _vm.taskActions.list
              ? _c("PlanUrlTaskListModal", {
                  attrs: {
                    "is-access-allow": _vm.isTaskAccess,
                    urlId: _vm.urlId,
                    service: _vm.service,
                    "hide-header-btn": _vm.hideHeaderBtn,
                  },
                  on: {
                    close: function ($event) {
                      _vm.$emit("close")
                      _vm.$plan.resetPlanCRUDState()
                      _vm.$plan.setPlanAction(null)
                    },
                    requestError: (err) => (_vm.requestErrorMessage = err),
                  },
                })
              : _vm._e(),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.requestErrorMessage
        ? _c(
            "ReactiveAlert",
            {
              staticClass: "reactive-alert_danger",
              attrs: { title: "Ошибка при сохранении" },
              on: {
                close: function ($event) {
                  _vm.requestErrorMessage = ""
                },
              },
            },
            [
              _c("p", {
                domProps: { innerHTML: _vm._s(_vm.requestErrorMessage) },
              }),
            ]
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }